<template>
  <div class="btn" :style="computeStyle">
    {{ text }}
    <maple-icon
      v-if="!text && iconName"
      :size="iconSize"
      :name="iconName"
      :color="iconColor"
    />
  </div>
</template>

<script>
import {
  THEME_START_COLOR,
  THEME_ENG_COLOR
} from '@/defines/environment/config'
export default {
  name: 'BtnConfigComponent',
  props: {
    height: {
      type: [Number, String],
      default: 0.52 // 26px=>0.52rem
    },
    width: {
      type: [Number, String],
      default: 0
    },
    bgStartColor: {
      type: String,
      default: THEME_START_COLOR
    },
    bgEndColor: {
      type: String,
      default: THEME_ENG_COLOR
    },
    bgDirection: {
      type: String,
      default: '90deg'
    },
    borderRadius: {
      type: Number,
      default: 0.26 // 13px=>.26rem
    },
    borderColor: {
      type: String,
      default: ''
    },
    // 默认使用渐变色
    hasBackground: {
      type: Boolean,
      default: false
    },
    hasBorder: {
      type: Boolean,
      default: false
    },
    hasBgImg: {
      type: Boolean,
      default: false
    },
    fontSize: {
      type: Number,
      default: 0.26 // 13px=>0.26rem
    },
    fontColor: {
      type: String,
      default: '#fff'
    },
    fontWeight: {
      type: String,
      default: ''
    },
    text: {
      type: String,
      default: ''
    },
    iconSize: {
      type: String,
      default: ''
    },
    iconColor: {
      type: String,
      default: ''
    },
    iconName: {
      type: String,
      default: ''
    },
    bgColor: {
      type: String,
      default: ''
    }
  },
  data() {
    return {}
  },
  computed: {
    computeStyle() {
      const borderStyle =
        this.hasBorder && this.borderColor
          ? `1px solid ${this.borderColor}`
          : 'none'
      const bgStyle = this.hasBackground && this.bgColor ? this.bgColor : 'none'
      const bgImage =
        this.hasBgImg && this.bgStartColor && this.bgEndColor
          ? `linear-gradient(${this.bgDirection}, ${this.bgStartColor}, ${this.bgEndColor} )`
          : 'none'
      return {
        fontSize: `${this.fontSize}rem`,
        color: `${this.fontColor}`,
        borderRadius: `${this.borderRadius}rem`,
        border: `${borderStyle}`,
        backgroundColor: `${bgStyle}`,
        backgroundImage: `${bgImage}`,
        height: `${this.height}rem`,
        width: this.width ? `${this.width}rem` : '',
        fontWeight: this.fontWeight
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.btn {
  @include flex-row-center;
}
</style>
